export interface ArticleBlock {
  heading: string;
  body: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export interface Article {
  slug: string;
  title: string;
  category: string;
  categoryName: string;
  summary: string;
  cover: string;
  year: number;
  rating: number;
  tags: string[];
  studio: string;
  director: string;
  episodes: string;
  content: ArticleBlock[];
  faq: FaqItem[];
}

export const articles: Article[] = [
  {
    slug: "guimie-zhiren",
    title: "鬼灭之刃：热血少年剑士的燃与泪",
    category: "rexue",
    categoryName: "日漫热血",
    summary:
      "少年炭治郎为救回变成鬼的妹妹祢豆子，踏上鬼杀队之路。极致的战斗作画、细腻的情感与燃到顶点的呼吸之技，让它成为新时代最具代表性的热血神作。",
    cover:
      "https://readdy.ai/api/search-image?query=Japanese%20anime%20illustration%20of%20a%20young%20swordsman%20in%20a%20checkered%20haori%20drawing%20a%20katana%20with%20flowing%20water%20blade%20effect%20in%20a%20dark%20forest%2C%20teal%20and%20crimson%20flames%2C%20dynamic%20pose%2C%20cinematic%20lighting%2C%20high%20quality%20digital%20art&width=600&height=800&seq=cover-guimie&orientation=portrait",
    year: 2019,
    rating: 9.4,
    tags: ["战斗", "少年", "催泪", "ufotable"],
    studio: "ufotable",
    director: "外崎春雄",
    episodes: "全26话 + 剧场版",
    content: [
      {
        heading: "故事梗概",
        body: "大正时代，卖炭少年灶门炭治郎一家惨遭鬼袭击，妹妹祢豆子也变成了鬼。为了寻找让妹妹变回人类的方法，也为了复仇，炭治郎加入鬼杀队，在一次次生死战斗中磨炼剑技，结识了伙伴，也揭开了鬼之始祖的层层阴谋。",
      },
      {
        heading: "为何封神",
        body: "ufotable 极致的摄影与作画，配合华丽又不失力量感的呼吸之剑演出，将每一场战斗都推至视觉巅峰。除了燃到极致的打斗，作品对亲情、羁绊与牺牲的刻画同样细腻，让人在燃与泪之间反复切换。",
      },
      {
        heading: "入坑建议",
        body: "TV动画第一季是完美的起点，之后接续《无限列车篇》剧场版与后续篇章。节奏紧凑、情感饱满，无论是老二次元还是新观众都能轻松入坑。",
      },
    ],
    faq: [
      { q: "鬼灭之刃适合第一次接触日漫的人看吗？", a: "非常合适。它节奏明快、情感饱满，作画顶级，故事简单直接又不失深度，是绝佳的入门热血番。" },
      { q: "鬼灭之刃一共有多少话？", a: "TV动画第一季26话，之后有剧场版《无限列车篇》以及多部续篇，剧情已进入大结局阶段。" },
    ],
  },
  {
    slug: "jijin-jiuren",
    title: "进击的巨人：宏大世界观下的自由之问",
    category: "rexue",
    categoryName: "日漫热血",
    summary:
      "高墙之内的人类对抗吞噬一切的巨人。从热血复仇到宏大哲学思辨，这部作品用前所未有的格局重新定义了热血动漫的高度。",
    cover:
      "https://readdy.ai/api/search-image?query=Japanese%20anime%20illustration%20of%20a%20colossal%20humanoid%20titan%20silhouette%20looming%20over%20massive%20stone%20walls%20under%20a%20dramatic%20orange%20sky%2C%20epic%20scale%2C%20tense%20cinematic%20atmosphere%2C%20high%20quality%20digital%20art&width=600&height=800&seq=cover-jijin&orientation=portrait",
    year: 2013,
    rating: 9.6,
    tags: ["巨兽", "悬疑", "末世", "宏大叙事"],
    studio: "WIT STUDIO / MAPPA",
    director: "荒木哲郎 / 林祐一郎",
    episodes: "全4季",
    content: [
      {
        heading: "故事梗概",
        body: "人类蜷缩在巨大的高墙之内，墙外则是以人类为食的巨人。少年艾伦亲眼目睹母亲被巨人吞食后，立志加入调查兵团，驱逐所有巨人。然而随着真相层层揭开，墙内的世界、巨人的起源与自由的代价，远比想象中残酷。",
      },
      {
        heading: "为何封神",
        body: "它是少数从热血复仇一路走向宏大哲学思辨的作品。环环相扣的伏笔、阵营立场的激烈碰撞、以及关于自由与和平的终极之问，让这部作品拥有了超越类型本身的力量与厚度。",
      },
      {
        heading: "观看提醒",
        body: "作品涉及较为沉重的主题与道德困境，观感并不轻松。但它带来的震撼与思考，值得每一位动画爱好者认真体验。",
      },
    ],
    faq: [
      { q: "进击的巨人整体是什么风格的番？", a: "前期是热血末世复仇番，后期逐渐转向政治博弈与哲学思辨，格局宏大、后劲十足。" },
      { q: "剧情会不会太压抑？", a: "确实偏沉重，人物命运残酷且选择艰难，但正因如此，故事的冲击力与深度也远超一般热血番。" },
    ],
  },
  {
    slug: "yiquan-chaoren",
    title: "一拳超人：最强英雄的另类热血",
    category: "rexue",
    categoryName: "日漫热血",
    summary:
      "一拳就能解决敌人的光头英雄埼玉，却因太过强大而陷入无聊。这部作品以极致的反差与顶级的战斗作画，重新解构了热血战斗的套路。",
    cover:
      "https://readdy.ai/api/search-image?query=Japanese%20anime%20illustration%20of%20a%20bald%20caped%20hero%20standing%20calmly%20with%20a%20single%20punch%20shockwave%20devastating%20a%20giant%20monster%2C%20dynamic%20action%2C%20comic%20style%2C%20high%20quality%20digital%20art&width=600&height=800&seq=cover-yiquan&orientation=portrait",
    year: 2015,
    rating: 9.2,
    tags: ["搞笑", "战斗", "反差", "Madhouse"],
    studio: "MADHOUSE",
    director: "夏目真悟",
    episodes: "全2季",
    content: [
      {
        heading: "故事梗概",
        body: "经过三年刻苦训练，普通人埼玉获得了可以一拳击败任何敌人的绝对力量，却也失去了作为英雄的热情。为找回生活的乐趣，他加入英雄协会，在一次次看似强大的危机中，用最朴实的一拳终结一切。",
      },
      {
        heading: "为何封神",
        body: "这部作品最迷人的地方在于巨大的反差：一边是无敌到无聊的主角，一边是阵容华丽、拼命燃烧的配角群像。顶级战斗作画与冷幽默并存，让它在搞笑与燃之间找到了绝佳的平衡。",
      },
      {
        heading: "入坑建议",
        body: "节奏轻松、笑点密集，战斗场面水准极高。适合想放松心情又期待高质量打斗的观众。",
      },
    ],
    faq: [
      { q: "一拳超人是纯搞笑的番吗？", a: "以搞笑和反差为核心，但战斗作画水准顶级，配角们热血拼命的故事线同样非常精彩。" },
    ],
  },
  {
    slug: "zhoushu-huizhan",
    title: "咒术回战：黑暗世界观下的咒力对决",
    category: "rexue",
    categoryName: "日漫热血",
    summary:
      "吞下诅咒之王手指的少年虎杖悠仁，踏入咒术师与咒灵对抗的暗黑世界。顶级的动作设计、独特的咒术设定，让这部作品迅速跻身新时代热血一线。",
    cover:
      "https://readdy.ai/api/search-image?query=Japanese%20anime%20illustration%20of%20a%20young%20sorcerer%20in%20a%20dark%20urban%20night%20surrounded%20by%20glowing%20cursed%20energy%20flames%2C%20intense%20battle%20pose%2C%20cinematic%20dark%20mood%2C%20high%20quality%20digital%20art&width=600&height=800&seq=cover-zhoushu&orientation=portrait",
    year: 2020,
    rating: 9.0,
    tags: ["咒术", "战斗", "暗黑", "MAPPA"],
    studio: "MAPPA",
    director: "朴性厚 / 御所园翔太",
    episodes: "全2季",
    content: [
      {
        heading: "故事梗概",
        body: "高中生虎杖悠仁为救人吞下了特级咒物两面宿傩的手指，成为宿傩的容器。在咒术高专老师五条悟的引荐下，他正式成为咒术师，与伏黑惠、钉崎野蔷薇等伙伴一同对抗威胁人类的咒灵。",
      },
      {
        heading: "亮点解析",
        body: "MAPPA 为这部作品带来了教科书级的动作演出，拳拳到肉的打斗流畅且极具冲击力。黑暗而深邃的咒术世界观、鲜明的人物塑造，让它在热血与暗黑之间走出属于自己的独特风格。",
      },
      {
        heading: "入坑建议",
        body: "前期节奏明快、打斗华丽，是视觉与爽感兼备的佳作。随着剧情推进，故事也逐步展开更为沉重的命运主题。",
      },
    ],
    faq: [
      { q: "咒术回战适合什么类型的观众？", a: "喜欢高质量动作打斗、暗黑世界观和群像塑造的观众都会很满意。" },
    ],
  },
  {
    slug: "nide-mingzi",
    title: "你的名字：穿越时空的恋爱奇旅",
    category: "lianai",
    categoryName: "日漫恋爱",
    summary:
      "新海诚导演代表作。生活在都市的少年与乡间少女在梦中互换身体，在时空错位中追寻彼此。唯美画面与感人故事，让它成为现象级恋爱电影。",
    cover:
      "https://readdy.ai/api/search-image?query=Japanese%20anime%20illustration%20of%20two%20teenagers%20standing%20on%20a%20hilltop%20overlooking%20a%20small%20town%20at%20dusk%20with%20a%20glowing%20comet%20splitting%20the%20sky%2C%20vibrant%20red%20and%20orange%20gradient%2C%20romantic%20cinematic%20mood%2C%20high%20quality%20digital%20art&width=600&height=800&seq=cover-nidemingzi&orientation=portrait",
    year: 2016,
    rating: 9.5,
    tags: ["新海诚", "奇幻", "催泪", "剧场版"],
    studio: "CoMix Wave Films",
    director: "新海诚",
    episodes: "剧场版电影",
    content: [
      {
        heading: "故事梗概",
        body: "东京少年立花泷与飞驒乡间少女宫水三叶，在梦中奇妙地互换身体，体验着彼此截然不同的生活。当彗星划破夜空，隐藏在身体互换背后的真相与一场跨越时间的追寻，就此展开。",
      },
      {
        heading: "为何动人",
        body: "新海诚标志性的唯美画风，将每一帧都雕琢成壁纸。而故事核心的追寻与错过，在精妙的叙事结构下层层递进，最终汇聚成一场跨越时空与遗忘的深情告白。",
      },
      {
        heading: "观影提示",
        body: "这是一部需要静心体会的剧场版电影，画面、音乐与情绪层层铺陈。建议在安静的环境中完整观看，体验那份穿越时空的心动。",
      },
    ],
    faq: [
      { q: "你的名字的故事会不会很难懂？", a: "前半段轻松有趣，后半段层层反转。叙事结构精巧但逻辑自洽，跟随剧情走就能完全理解那份感动。" },
    ],
  },
  {
    slug: "siyue-shi-nidehuangyan",
    title: "四月是你的谎言：藏在琴声里的爱",
    category: "lianai",
    categoryName: "日漫恋爱",
    summary:
      "钢琴少年有马公生，遇见了如樱花般绚烂又注定凋零的小提琴少女宫园薰。这部以音乐与告别为主题的恋爱番，让无数观众泪流满面。",
    cover:
      "https://readdy.ai/api/search-image?query=Japanese%20anime%20illustration%20of%20a%20young%20girl%20playing%20a%20violin%20under%20falling%20cherry%20blossom%20petals%20beside%20a%20piano%2C%20warm%20spring%20golden%20light%2C%20melancholic%20romantic%20atmosphere%2C%20high%20quality%20digital%20art&width=600&height=800&seq=cover-siyue&orientation=portrait",
    year: 2014,
    rating: 9.1,
    tags: ["音乐", "催泪", "校园", "青春"],
    studio: "A-1 Pictures",
    director: "石黑恭平",
    episodes: "全22话",
    content: [
      {
        heading: "故事梗概",
        body: "曾经在钢琴赛场上耀眼的少年有马公生，因母亲的离世而无法再听到自己的琴声。直到他遇见了自由奔放、热烈如火焰的小提琴手宫园薰，在她的牵动下，公生重新踏上音乐与人生的舞台。",
      },
      {
        heading: "情感内核",
        body: "作品以音乐为载体，细腻描绘了青春里最隐秘的心动与最残酷的告别。宫园薰阳光之下的隐忍与付出，让每一段琴声都浸透了无法言说的深情，结尾的震撼与泪水令人久久难忘。",
      },
      {
        heading: "观前提示",
        body: "这是一部需要备好纸巾的恋爱番。音乐演出精彩绝伦，情感的浓度极高，适合喜欢细腻青春故事的观众。",
      },
    ],
    faq: [
      { q: "四月是你的谎言是悲剧结局吗？", a: "关于结局不便剧透，但作品正是以告别与传承为主题，情感冲击力极强，是公认的催泪佳作。" },
    ],
  },
  {
    slug: "huiye-daxiaojie",
    title: "辉夜大小姐想让我告白：天才们的恋爱头脑战",
    category: "lianai",
    categoryName: "日漫恋爱",
    summary:
      "两位天才学生会长与副会长，为了谁先告白谁就输了而斗智斗勇。这部校园恋爱喜剧以密集笑点与超高智商博弈，让人笑到停不下来。",
    cover:
      "https://readdy.ai/api/search-image?query=Japanese%20anime%20illustration%20of%20a%20confident%20high%20school%20boy%20and%20a%20graceful%20school%20president%20girl%20facing%20each%20other%20in%20a%20sunlit%20school%20courtyard%2C%20clean%20bright%20romantic%20comedy%20style%2C%20high%20quality%20digital%20art&width=600&height=800&seq=cover-huiye&orientation=portrait",
    year: 2019,
    rating: 9.2,
    tags: ["校园", "搞笑", "恋爱", "A-1 Pictures"],
    studio: "A-1 Pictures",
    director: "畠山守",
    episodes: "全3季 + 剧场版",
    content: [
      {
        heading: "故事梗概",
        body: "学生会会长白银御行与副会长四宫辉夜，互相倾慕却谁也不肯先低头告白。为了迫使对方先开口，两人展开一场场堪称恋爱头脑战的心理博弈，而两人想象与现实的巨大反差，贡献了密集的笑点。",
      },
      {
        heading: "看点所在",
        body: "作品最有趣的地方，在于天才们的心动与傲娇被无限放大。严肃的博弈配上扭曲的内心戏，让每集都笑点密集。而随着感情线的推进，甜蜜与成长的瞬间也愈发打动人心。",
      },
      {
        heading: "入坑建议",
        body: "轻松解压、笑点密集，非常适合放松时观看。爱情与喜剧融合得恰到好处，是一部越看越上头的恋爱番。",
      },
    ],
    faq: [
      { q: "辉夜大小姐是纯搞笑的恋爱番吗？", a: "前期以搞笑为主，后期情感线逐步深化，甜度与笑点兼备，节奏把握非常出色。" },
    ],
  },
  {
    slug: "long-yu-hu",
    title: "龙与虎：青春里最别扭的告白",
    category: "lianai",
    categoryName: "日漫恋爱",
    summary:
      "凶巴巴的掌上老虎逢坂大河与温柔少年高须龙儿，因彼此助攻对方的恋爱而越走越近。经典校园恋爱番，青春气息扑面而来。",
    cover:
      "https://readdy.ai/api/search-image?query=Japanese%20anime%20illustration%20of%20a%20small%20blonde%20schoolgirl%20and%20a%20gentle%20schoolboy%20walking%20together%20on%20a%20school%20road%20at%20sunset%2C%20warm%20golden%20light%2C%20cute%20romantic%20youth%20style%2C%20high%20quality%20digital%20art&width=600&height=800&seq=cover-longyu&orientation=portrait",
    year: 2008,
    rating: 9.0,
    tags: ["校园", "青春", "经典", "J.C.STAFF"],
    studio: "J.C.STAFF",
    director: "长井龙雪",
    episodes: "全25话",
    content: [
      {
        heading: "故事梗概",
        body: "外表温柔却家务万能的龙儿，与外表娇小内心凶悍的掌上老虎大河意外同住一个屋檐下。两人决定互相助攻对方追求心上人，却在一次次闹剧中，渐渐意识到真正在乎的人就在身边。",
      },
      {
        heading: "经典魅力",
        body: "这部作品是校园恋爱番的标杆之作。人物塑造鲜活立体，青春里那份别扭、青涩又真挚的心动被刻画得淋漓尽致，圣诞夜的名场面更是让无数观众铭记至今。",
      },
      {
        heading: "入坑建议",
        body: "节奏细腻、情感真挚，是了解经典校园恋爱番的绝佳选择。看似轻松的外表下，藏着打动人心的成长与告白。",
      },
    ],
    faq: [
      { q: "龙与虎的故事节奏慢吗？", a: "节奏张弛有度，前期轻松搞笑，后期情感层层递进，是全年龄向的经典青春恋爱番。" },
    ],
  },
  {
    slug: "siwang-biji",
    title: "死亡笔记：天才与天才的智商对决",
    category: "xuanyi",
    categoryName: "日漫悬疑",
    summary:
      "高中生夜神月捡到一本写上名字就会死的死亡笔记，决心成为新世界的神。随之而来的，是他与天才侦探L之间惊心动魄的智力博弈。",
    cover:
      "https://readdy.ai/api/search-image?query=Japanese%20anime%20illustration%20of%20a%20mysterious%20notebook%20and%20a%20red%20apple%20on%20a%20desk%20in%20a%20dark%20shadowy%20room%2C%20dramatic%20moody%20lighting%2C%20suspenseful%20thriller%20atmosphere%2C%20high%20quality%20digital%20art&width=600&height=800&seq=cover-siwang&orientation=portrait",
    year: 2006,
    rating: 9.4,
    tags: ["推理", "斗智", "暗黑", "经典"],
    studio: "MADHOUSE",
    director: "荒木哲郎",
    episodes: "全37话",
    content: [
      {
        heading: "故事梗概",
        body: "高中生夜神月偶然拾获死神的死亡笔记，凡被写上名字且知晓其样貌之人都会死亡。自认正义的月以基拉之名制裁罪犯，渴望建立理想的新世界，却引来了世界第一侦探L的挑战。",
      },
      {
        heading: "为何封神",
        body: "这是一场纯粹的智商博弈。月与L之间层层设局、步步反制的对决，让整部作品始终保持在极致的紧张感中。关于正义与神的思辨，也赋予了这部悬疑作远超表面的深度。",
      },
      {
        heading: "入坑建议",
        body: "逻辑严谨、节奏飞快，全程高能。适合喜欢烧脑推理与正邪思辨的观众，是悬疑动画绕不开的经典。",
      },
    ],
    faq: [
      { q: "死亡笔记会不会很难看懂？", a: "设定简单、节奏紧凑，斗智过程虽有反转但逻辑清晰，跟随主角的每一步推理就能完全沉浸其中。" },
    ],
  },
  {
    slug: "mingyun-shizhimen",
    title: "命运石之门：时间线的拯救与抉择",
    category: "xuanyi",
    categoryName: "日漫悬疑",
    summary:
      "自称疯狂科学家的冈部伦太郎，意外发现可以改变世界线的能力。这部硬核科幻悬疑番以精妙的设定与神级伏笔回收，被誉为时空穿越题材的天花板。",
    cover:
      "https://readdy.ai/api/search-image?query=Japanese%20anime%20illustration%20of%20a%20young%20scientist%20with%20a%20phone%20in%20front%20of%20glowing%20clockwork%20gears%20and%20circuit%20patterns%2C%20amber%20and%20red%20lighting%2C%20time%20travel%20sci-fi%20atmosphere%2C%20high%20quality%20digital%20art&width=600&height=800&seq=cover-mingyun&orientation=portrait",
    year: 2011,
    rating: 9.3,
    tags: ["科幻", "时空", "烧脑", "神作"],
    studio: "WHITE FOX",
    director: "佐藤卓哉 / 滨崎博嗣",
    episodes: "全24话",
    content: [
      {
        heading: "故事梗概",
        body: "秋叶原的自称疯狂科学家冈部伦太郎与伙伴们制造出可以发送信息到过去的电话微波炉，却由此触发了一系列不可控的世界线变动。为了拯救重要之人，他必须在无数时间线中做出痛苦的选择。",
      },
      {
        heading: "魅力所在",
        body: "这部作品最令人惊叹的，是它精妙到极致的伏笔回收。前期铺垫的每一处细节，都会在后期的神展开中迎来震撼的反转。人物在时间线中的挣扎与牺牲，让硬核科幻里充满了滚烫的人情。",
      },
      {
        heading: "观看提醒",
        body: "前半部分节奏较慢、铺垫较多，请务必耐心坚持。当所有伏笔开始回收的那一刻起，你会明白它为何被称为时空穿越神作。",
      },
    ],
    faq: [
      { q: "命运石之门前期很无聊吗？", a: "前期以铺垫为主，节奏偏慢，但所有看似日常的细节都是关键伏笔，坚持看到中后期会迎来爆炸级的展开。" },
    ],
  },
  {
    slug: "yueding-de-huanxiangdao",
    title: "约定的梦幻岛：高墙内的残酷真相",
    category: "xuanyi",
    categoryName: "日漫悬疑",
    summary:
      "孩子们幸福生活的孤儿院，竟隐藏着可怕的真相。逃离、追捕与希望，这部黑暗童话般的悬疑番，用温柔的画风讲述了一个残酷又动人的故事。",
    cover:
      "https://readdy.ai/api/search-image?query=Japanese%20anime%20illustration%20of%20three%20children%20standing%20at%20a%20forest%20edge%20looking%20at%20a%20large%20mysterious%20orphanage%20behind%20a%20tall%20fence%2C%20soft%20light%20but%20ominous%20mood%2C%20dark%20fantasy%20suspense%2C%20high%20quality%20digital%20art&width=600&height=800&seq=cover-huanxiang&orientation=portrait",
    year: 2019,
    rating: 9.0,
    tags: ["惊悚", "智斗", "逃生", "CloverWorks"],
    studio: "CloverWorks",
    director: "神户守",
    episodes: "全2季",
    content: [
      {
        heading: "故事梗概",
        body: "在GF之家孤儿院里，孩子们过着被妈妈温柔守护的幸福生活。然而艾玛与诺曼偶然发现，这座天堂其实是圈养他们的农场，孩子长到一定年龄就会被当作食物献祭。为了活下去，三人策划起一场与全世界的惊天逃亡。",
      },
      {
        heading: "看点所在",
        body: "温柔的画风与残酷的真相形成巨大反差，营造出独特的悬疑张力。孩子们利用智慧与妈妈斗智斗勇、步步惊心的过程，既烧脑又扣人心弦，角色的成长与信任更让人动容。",
      },
      {
        heading: "入坑建议",
        body: "第一季节奏紧凑、悬念迭起，是极佳的入坑选择。建议先完整观看第一季，体验那段高密度的智斗逃生。",
      },
    ],
    faq: [
      { q: "约定的梦幻岛恐怖吗？", a: "它不是血腥恐怖，而是以心理惊悚和悬疑氛围为主，配合孩子们与真相的对抗，紧张感十足但不至于吓人。" },
    ],
  },
  {
    slug: "xiamu-yourenzhang",
    title: "夏目友人帐：温柔与孤独的相遇",
    category: "zhiyu",
    categoryName: "日漫治愈",
    summary:
      "能看见妖怪的少年夏目贵志，继承了祖母的友人帐。在与一个个妖怪相遇、相识又告别的过程中，他学会了温柔与成长。夏日限定般的治愈佳作。",
    cover:
      "https://readdy.ai/api/search-image?query=Japanese%20anime%20illustration%20of%20a%20gentle%20young%20man%20with%20short%20brown%20hair%20and%20a%20small%20white%20cat%20spirit%20on%20his%20shoulder%2C%20standing%20in%20a%20peaceful%20sunlit%20forest%2C%20warm%20soothing%20atmosphere%2C%20high%20quality%20digital%20art&width=600&height=800&seq=cover-xiamu&orientation=portrait",
    year: 2008,
    rating: 9.3,
    tags: ["治愈", "妖怪", "温馨", "日常"],
    studio: "朱夏",
    director: "大森贵弘",
    episodes: "全7季",
    content: [
      {
        heading: "故事梗概",
        body: "自小能看见妖怪、性格温柔的少年夏目贵志，在继承祖母的友人帐后，决定将上面记录着名字的妖怪们的名字一一归还。在与妖怪们相遇、相处、分别的过程中，他逐渐体会到被爱与被理解的温暖。",
      },
      {
        heading: "治愈之处",
        body: "这是一部没有激烈冲突、只有温柔涟漪的作品。每一个妖怪背后都有一段或遗憾或温暖的故事，夏目与猫咪老师的日常互动更是萌点满满。淡淡的悲伤中，总藏着让人心头一暖的治愈。",
      },
      {
        heading: "入坑建议",
        body: "节奏舒缓、氛围治愈，适合在疲惫时静静观看。四季更迭下的单元故事，越看越能体会到那份绵长的温柔。",
      },
    ],
    faq: [
      { q: "夏目友人帐每一季都可以单独看吗？", a: "虽然季与季之间有连贯的人物关系，但多以单元剧形式展开，从任意一季入坑都能很快进入温柔的节奏中。" },
    ],
  },
  {
    slug: "ziluolan-yonghenghuayuan",
    title: "紫罗兰永恒花园：书写情感的自动手记人偶",
    category: "zhiyu",
    categoryName: "日漫治愈",
    summary:
      "失去情感的战场少女薇尔莉特，成为代笔写信的自动手记人偶，在替他人传达思念的过程中，逐渐理解爱的含义。极致唯美的治愈佳作。",
    cover:
      "https://readdy.ai/api/search-image?query=Japanese%20anime%20illustration%20of%20a%20young%20girl%20with%20golden%20hair%20writing%20a%20letter%20at%20a%20window%20in%20warm%20afternoon%20light%2C%20elegant%20nostalgic%20atmosphere%2C%20gorgeous%20cinematic%20detail%2C%20high%20quality%20digital%20art&width=600&height=800&seq=cover-ziluolan&orientation=portrait",
    year: 2018,
    rating: 9.5,
    tags: ["治愈", "唯美", "催泪", "京都动画"],
    studio: "京都动画",
    director: "石立太一",
    episodes: "全13话 + 剧场版",
    content: [
      {
        heading: "故事梗概",
        body: "在战后世界，曾经作为杀戮兵器的少女薇尔莉特，装上义肢后成为一名代笔写信的自动手记人偶。她在替不同的人传达思念的过程中，一步步理解自己从未体会过的爱究竟是什么。",
      },
      {
        heading: "唯美与深情",
        body: "京都动画以登峰造极的画面，将每一帧都绘制得如油画般细腻。作品以信件为线索，串联起一个个关于亲情、友情与爱情的故事，在克制而深情的叙事中，让人止不住落泪。",
      },
      {
        heading: "观前提示",
        body: "这是一部需要静心体味的情感佳作。每集一个温柔的故事，请备好纸巾，在安静的夜晚静静感受那份跨越生死的深情。",
      },
    ],
    faq: [
      { q: "紫罗兰永恒花园是单元剧还是连续剧？", a: "主线贯穿始终，同时以多个代笔单元故事展开，每一集都情感饱满、独立动人，又共同推动薇尔莉特的成长。" },
    ],
  },
  {
    slug: "weiwenhua",
    title: "未闻花名：夏天、伙伴与说不出口的告别",
    category: "zhiyu",
    categoryName: "日漫治愈",
    summary:
      "为了帮儿时的伙伴面码实现愿望，早已疏远的超和平Busters再次相聚。这部关于青春、遗憾与救赎的治愈番，用一场夏天讲述了一场盛大的告别。",
    cover:
      "https://readdy.ai/api/search-image?query=Japanese%20anime%20illustration%20of%20a%20group%20of%20children%20gathering%20under%20a%20summer%20evening%20sky%20with%20glowing%20fireflies%20and%20fireworks%2C%20nostalgic%20warm%20light%2C%20bittersweet%20youth%20atmosphere%2C%20high%20quality%20digital%20art&width=600&height=800&seq=cover-weiwenhua&orientation=portrait",
    year: 2011,
    rating: 9.2,
    tags: ["催泪", "青春", "友情", "A-1 Pictures"],
    studio: "A-1 Pictures",
    director: "长井龙雪",
    episodes: "全11话",
    content: [
      {
        heading: "故事梗概",
        body: "儿时的玩伴们因意外渐行渐远，直到一天，已故多年的面码以幽灵之姿出现在男主角仁太面前，希望他能帮助自己实现愿望。为了让超和平Busters的伙伴们重新相聚，仁太踏上了寻找答案的旅程。",
      },
      {
        heading: "感动之处",
        body: "作品将青春里的误会、逃避与深埋心底的遗憾一一摊开，再通过面码的归来，让每个人都获得直面过去的勇气。当尘封多年的心结被解开，那句最喜欢你了的回响，足以让所有观众瞬间泪崩。",
      },
      {
        heading: "观前提示",
        body: "这是公认的催泪神作，请准备好充足纸巾。青春、友情与告别的主题，会在最后一刻给你最猛烈的暴击。",
      },
    ],
    faq: [
      { q: "未闻花名的结局虐不虐？", a: "情感浓度极高，是一场温柔又盛大的告别，结局催泪但充满救赎与希望，是治愈系的经典代表。" },
    ],
  },
  {
    slug: "xinshiji-fuyinshi",
    title: "新世纪福音战士：人类补完的哲学史诗",
    category: "jizhan",
    categoryName: "日漫机战",
    summary:
      "少年少女驾驶巨型人形兵器EVA迎战使徒，却在战斗中直面自身的创伤与孤独。这部作品以颠覆性的叙事，将机战题材推向哲学与心理学的巅峰。",
    cover:
      "https://readdy.ai/api/search-image?query=Japanese%20anime%20illustration%20of%20a%20slim%20purple%20and%20green%20giant%20humanoid%20mecha%20silhouette%20standing%20in%20a%20city%20under%20a%20tense%20red%20sky%2C%20dramatic%20eerie%20atmosphere%2C%20high%20quality%20digital%20art&width=600&height=800&seq=cover-fuyinshi&orientation=portrait",
    year: 1995,
    rating: 9.6,
    tags: ["心理", "经典", "宗教", "GAINAX"],
    studio: "GAINAX",
    director: "庵野秀明",
    episodes: "全26话 + 剧场版",
    content: [
      {
        heading: "故事梗概",
        body: "在第二次冲击后的世界，14岁少年碇真嗣被父亲召唤，驾驶巨型兵器EVA迎战不断来袭的使徒。然而比起敌人的威胁，更令他痛苦的，是与同伴、父亲以及自己内心的和解。",
      },
      {
        heading: "深度所在",
        body: "EVA表面是机战，内核却是对孤独、创伤与自我认同的深刻剖析。庵野秀明以近乎残酷的坦诚，将角色的内心挣扎赤裸裸地展现在观众面前，其哲学思辨与心理描写至今仍被反复解读。",
      },
      {
        heading: "观看提醒",
        body: "这部作品基调压抑、内涵晦涩，观感并不轻松。它是一部需要思考而非仅求爽感的作品，喜欢深度叙事的观众会获得极大满足。",
      },
    ],
    faq: [
      { q: "EVA适合第一次看机战番的人吗？", a: "它并非传统意义上的爽快机战番，而是以心理描写和哲学思考为核心。若想从燃开始了解机战，建议先看其他作品，再来感受EVA的深度。" },
    ],
  },
  {
    slug: "gaoda-seed",
    title: "机动战士高达SEED：宇宙纪元的热血战争",
    category: "jizhan",
    categoryName: "日漫机战",
    summary:
      "调整者与自然人之间的战争一触即发，少年基拉·大和被迫驾驶高达踏入战场。作为新世纪高达的代表作，它将机战燃点与人文思考完美结合。",
    cover:
      "https://readdy.ai/api/search-image?query=Japanese%20anime%20illustration%20of%20a%20white%20and%20blue%20giant%20mecha%20with%20winged%20backpack%20hovering%20in%20space%20battle%20amid%20debris%20and%20explosions%2C%20epic%20sci-fi%20action%2C%20high%20quality%20digital%20art&width=600&height=800&seq=cover-gaoda&orientation=portrait",
    year: 2002,
    rating: 9.1,
    tags: ["高达", "宇宙", "战争", "经典"],
    studio: "SUNRISE",
    director: "福田己津央",
    episodes: "全50话",
    content: [
      {
        heading: "故事梗概",
        body: "在基因改良技术普及的未来，经过基因调整的调整者与自然发生冲突，战争全面爆发。调整者少年基拉·大和被卷入战火，驾驶机动战士高达，与童年挚友、战友阿斯拉在战场上兵戎相见，寻找着守护与和平的道路。",
      },
      {
        heading: "燃与思",
        body: "作为新世纪高达的里程碑，SEED拥有华丽的机设、炫目的战斗与大量震撼人心的名场面。同时，它关于战争、身份认同与友情命运的思考，也让这部机战番在燃之外拥有了沉甸甸的分量。",
      },
      {
        heading: "入坑建议",
        body: "节奏明快、名场面众多，是了解高达系列的极佳入口。既是爽快的机战，也是值得回味的战争史诗。",
      },
    ],
    faq: [
      { q: "没看过高达系列能直接看SEED吗？", a: "完全可以。SEED是独立的世界观故事，不需要任何前作铺垫，是很多人的高达入坑作。" },
    ],
  },
  {
    slug: "tianyuan-tupo",
    title: "天元突破：燃烧螺旋的热血浪漫",
    category: "jizhan",
    categoryName: "日漫机战",
    summary:
      "从地底世界到宇宙尽头，西蒙与卡米那驾驶机器人突破一切阻碍。这部作品以夸张到极致的想象力，将热血与浪漫燃到天际，是机战番里的燃之顶点。",
    cover:
      "https://readdy.ai/api/search-image?query=Japanese%20anime%20illustration%20of%20a%20colossal%20spiral%20shaped%20drill%20robot%20breaking%20through%20the%20ground%20into%20a%20vast%20starry%20sky%2C%20dramatic%20flame%20and%20energy%2C%20over%20the%20top%20hot-blooded%20style%2C%20high%20quality%20digital%20art&width=600&height=800&seq=cover-tianyuan&orientation=portrait",
    year: 2007,
    rating: 9.4,
    tags: ["热血", "钻头", "燃", "GAINAX"],
    studio: "GAINAX",
    director: "今石洋之",
    episodes: "全27话",
    content: [
      {
        heading: "故事梗概",
        body: "生活在地底村落的少年西蒙，偶然发掘出神秘的钻头机器人。在热血兄长卡米那的带领下，他与伙伴们一路突破地底、地表乃至整个银河系，与统治宇宙的螺旋王展开终极对决。",
      },
      {
        heading: "燃之顶点",
        body: "今石洋之标志性的夸张演出与燃到极致的镜头语言，让这部作品的每一场战斗都充满想象力。从男人的浪漫就是钻头到天元突破，它用近乎失控的热血，讲述了一个关于勇气、继承与超越的动人故事。",
      },
      {
        heading: "入坑建议",
        body: "这是一部为燃而生的作品，请调整到最热血的心态观看。前半段的天真热血与后半段的悲壮成长，会让你大呼过瘾。",
      },
    ],
    faq: [
      { q: "天元突破的画风会不会太夸张？", a: "这正是它的特色。夸张到极致的演出和设定是这部作品热血魅力的来源，越燃越过瘾。" },
    ],
  },
  {
    slug: "qianyu-qianxun",
    title: "千与千寻：通往幻想乡的成长之旅",
    category: "shenzuo",
    categoryName: "日漫神作",
    summary:
      "宫崎骏巅峰之作。少女千寻误入神灵世界，为救父母而在一座澡堂打工。这部拿下奥斯卡最佳动画的神作，以天马行空的想象讲述了一个温柔又深刻的成长故事。",
    cover:
      "https://readdy.ai/api/search-image?query=Japanese%20anime%20illustration%20of%20a%20young%20girl%20in%20a%20kimono%20standing%20in%20front%20of%20a%20grand%20traditional%20japanese%20bathhouse%20at%20dusk%20with%20warm%20lantern%20light%2C%20ghibli%20inspired%20fantasy%20atmosphere%2C%20high%20quality%20digital%20art&width=600&height=800&seq=cover-qianyu&orientation=portrait",
    year: 2001,
    rating: 9.7,
    tags: ["宫崎骏", "吉卜力", "奇幻", "奥斯卡"],
    studio: "吉卜力工作室",
    director: "宫崎骏",
    episodes: "剧场版电影",
    content: [
      {
        heading: "故事梗概",
        body: "十岁的少女千寻随父母搬家的途中，误入一座神灵栖息的小镇。父母因贪吃变成猪，千寻为了拯救父母，不得不在汤婆婆经营的澡堂中工作，并在无脸男、白龙等角色的陪伴下，一步步学会勇敢与担当。",
      },
      {
        heading: "为何伟大",
        body: "宫崎骏用天马行空的想象力，构建了一个充满象征意义的神灵世界。它既是一场奇幻冒险，也是一段关于成长、坚持与不忘初心的寓言，画面之精美、想象之瑰丽，让它成为动画影史永恒的经典。",
      },
      {
        heading: "观影提示",
        body: "这是适合全家共赏的动画电影，无论年龄都能从中获得属于自己的感动。温柔的画风与深刻的内核，让它值得被反复回味。",
      },
    ],
    faq: [
      { q: "千与千寻适合和孩子一起看吗？", a: "非常适合。它是全年龄向的经典，孩子看到奇幻冒险，大人则能体会到成长与坚守的深意。" },
    ],
  },
  {
    slug: "gangzhi-lianjinshushi",
    title: "钢之炼金术师FA：等价交换的真理之路",
    category: "shenzuo",
    categoryName: "日漫神作",
    summary:
      "为复活母亲而进行人体炼成的兄弟俩，付出了惨痛代价。爱德华与阿尔冯斯踏上追寻贤者之石、夺回身体之旅。被誉为零差评的动画神作。",
    cover:
      "https://readdy.ai/api/search-image?query=Japanese%20anime%20illustration%20of%20two%20young%20alchemist%20brothers%20one%20with%20steel%20armor%20arm%20standing%20in%20a%20golden%20alchemy%20transmutation%20circle%20glow%2C%20dramatic%20warm%20lighting%2C%20epic%20adventure%20mood%2C%20high%20quality%20digital%20art&width=600&height=800&seq=cover-gangzhi&orientation=portrait",
    year: 2009,
    rating: 9.8,
    tags: ["冒险", "兄弟", "热血", "零差评"],
    studio: "BONES",
    director: "入江泰浩",
    episodes: "全64话",
    content: [
      {
        heading: "故事梗概",
        body: "天才炼金术师兄弟爱德华与阿尔冯斯，因违规进行人体炼成而付出惨痛代价：弟弟失去了身体，哥哥失去了一只手臂和一条腿。为了夺回一切，两人踏上寻找贤者之石的旅程，也逐渐卷入了关于国家、阴谋与真理的巨大漩涡。",
      },
      {
        heading: "为何零差评",
        body: "这部作品拥有教科书级的完整叙事：伏笔严谨、回收完美，人物群像鲜活，主题深刻却不沉重。它既是一部充满热血与冒险的少年漫，也是一部关于牺牲、救赎与等价交换的人生寓言。",
      },
      {
        heading: "入坑建议",
        body: "请直接观看2009年的《钢之炼金术师FA》，它忠于原作、叙事完整。剧情环环相扣，越到后期越精彩，是公认的零差评神作。",
      },
    ],
    faq: [
      { q: "钢炼FA和03版有什么区别？", a: "03版前中期相同但后期为原创结局；FA完全忠实原作，故事完整、伏笔回收完美，通常推荐优先看FA。" },
      { q: "钢之炼金术师FA适合什么人看？", a: "几乎适合所有观众。它融合热血、冒险、亲情与深刻思考，是公认的动画入坑与封神之作。" },
    ],
  },
  {
    slug: "xingji-niuzai",
    title: "星际牛仔：太空爵士与不羁浪漫",
    category: "shenzuo",
    categoryName: "日漫神作",
    summary:
      "赏金猎人斯派克与搭档杰特，在广袤的太空与弥漫的爵士乐中追寻过去。这部作品将牛仔浪漫与哲学孤独融为一体，是动画史上的风格化巅峰。",
    cover:
      "https://readdy.ai/api/search-image?query=Japanese%20anime%20illustration%20of%20a%20cool%20bounty%20hunter%20in%20a%20long%20coat%20with%20spiky%20hair%20standing%20in%20a%20noir%20spaceship%20hangar%20at%20night%2C%20jazz%20neon%20lighting%2C%20stylized%20cinematic%20mood%2C%20high%20quality%20digital%20art&width=600&height=800&seq=cover-xingji&orientation=portrait",
    year: 1998,
    rating: 9.6,
    tags: ["太空", "爵士", "经典", "风格化"],
    studio: "SUNRISE",
    director: "渡边信一郎",
    episodes: "全26话",
    content: [
      {
        heading: "故事梗概",
        body: "在近未来的太阳系，落魄赏金猎人斯派克与搭档杰特驾驶着飞船比波普号四处漂泊，追捕通缉犯。途中，他们遇见了性格各异的同伴，也在一次次任务与爵士乐中，各自面对无法逃避的过去。",
      },
      {
        heading: "风格巅峰",
        body: "渡边信一郎将太空、西部片、黑色电影与爵士乐完美融合，打造出一部独一无二的作品。潇洒不羁的角色、充满格调的画面与让人上头的配乐，共同构成了一场献给成年人的浪漫漂泊。",
      },
      {
        heading: "观前提示",
        body: "这是一部氛围感极强、节奏随性的作品，不以传统热血见长。请带着品味爵士乐的心情，慢慢体会那种洒脱中的孤独与深情。",
      },
    ],
    faq: [
      { q: "星际牛仔的观感会不会很闷？", a: "它节奏随性、重在氛围营造，但每集都有精彩的动作与幽默瞬间。带着品味格调的心态观看，会越看越上头。" },
    ],
  },
];

export const heroFeatured = ["gangzhi-lianjinshushi", "nide-mingzi", "guimie-zhiren", "xinshiji-fuyinshi", "qianyu-qianxun", "xingji-niuzai"];

export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter((a) => a.category === slug);
}

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((a) => a.slug === slug);
}